import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/apps/web/src/app/(networks)/(evm)/[chainId]/providers.tsx");
